<div class="time-period-selection" *ngIf="data">
  <label class="title">{{ 'module.shared.buildingEfficiencyWizard.step1.titleText' | translate }}</label>

  <div class="date">
    <label class="question">{{ 'module.shared.buildingEfficiencyWizard.step1.periodQuestionText' | translate }}</label>

    <div class="period-option1">
      <mat-radio-button class="radio" [disableRipple]="true" [checked]="!data.hasTimePeriod" (change)="onSelectionChange(false)">
        <p class="label-text">
          {{ 'module.shared.buildingEfficiencyWizard.step1.period1OptionText' | translate }}
        </p>
        <span class="period">
          <p class="text">
            {{ 'module.shared.buildingEfficiencyWizard.step1.startDateText' | translate }}
          </p>
          <p class="value">{{ getDisplayDate(data.defaultStartDate) }}</p>
        </span>
        <span class="period2">
          <p class="text">
            {{ 'module.shared.buildingEfficiencyWizard.step1.endDateText' | translate }}
          </p>
          <p class="value">{{ getDisplayDate(data.defaultEndDate) }}</p>
        </span>
      </mat-radio-button>
    </div>

    <div class="period-option2">
      <mat-radio-button class="radio" [disableRipple]="true" [checked]="data.hasTimePeriod" (change)="onSelectionChange(true)">
        <tr class="user-defined-period">
          <td class="row1">
            <tr class="text">
              {{
                'module.shared.buildingEfficiencyWizard.step1.period2OptionText' | translate
              }}
            </tr>
          </td>
          <td class="row2">
            <tr class="date-picker">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'module.shared.buildingEfficiencyWizard.step1.startDateText' | translate }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="dp"
                  [formControl]="startDatePicker"
                  placeholder="{{ 'module.shared.buildingEfficiencyWizard.step1.startDateText' | translate }}"
                  (ngModelChange)="dateChanged()"
                  [min]="datePickerMinDate"
                  [max]="datePickerMaxDate"
                  readonly
                />
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp startView="year" (monthSelected)="selectedMonthHandler($event, dp)" panelClass="efficiency-analysis-month-picker">
                </mat-datepicker>
              </mat-form-field>
            </tr>
          </td>
          <td class="row3">
            <tr>
              <h6 class="end-date-header">
                {{ 'module.shared.buildingEfficiencyWizard.step1.endDateText' | translate }}
              </h6>
            </tr>
            <tr class="content">
              <td class="value" *ngIf="data.userDefinedEndDate !== null">
                {{ displayEndDate }}
              </td>
            </tr>
          </td>
        </tr>
      </mat-radio-button>
    </div>
  </div>

  <div class="floor-area">
    <div class="question-container">
      <label class="question">{{ 'module.shared.buildingEfficiencyWizard.step1.floorAreaQuestionText' | translate }}</label>
      <span class="fa fa-info-circle" matTooltip="{{ note }}" matTooltipPosition="above"></span>
    </div>
    <div class="input">
      <label class="object-type">{{ data.buildingEfficiencyData.buildingTypeName }}</label>
      <mat-form-field class="input-value label">
        <mat-label>{{ 'module.shared.buildingEfficiencyWizard.step1.floorAreaLabelText' | translate }}</mat-label>
        <input
          title="floor-area"
          matInput
          [(ngModel)]="floorArea"
          autocomplete="off"
          maxlength="4"
          (ngModelChange)="floorAreaChange()"
          (focus)="focus()"
          (blur)="blur()"
          (keypress)="numberOnly($event)"
        />
      </mat-form-field>
      <label class="unit-label">{{ 'module.shared.buildingEfficiencyWizard.step1.floorAreaUnitText' | translate }}</label>
    </div>
  </div>
</div>
